var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTailoredFinanceOptions32 = function SvgTailoredFinanceOptions32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.404 28.2v1.2c0 .159.065.311.18.424a.627.627 0 0 0 .438.176h1.363c.163 0 .32-.063.435-.175a.59.59 0 0 0 .18-.423v-5.106a.68.68 0 0 0-.19-.468 3.002 3.002 0 0 0-1.18-.726 1.897 1.897 0 0 0-.627-.102h-7.006a1.897 1.897 0 0 0-.626.102 3.002 3.002 0 0 0-1.18.726.68.68 0 0 0-.191.468v5.106c0 .159.065.31.18.423a.624.624 0 0 0 .436.175h1.362a.627.627 0 0 0 .437-.176.592.592 0 0 0 .181-.425V28.2h5.808Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.5h2m7 0h2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22s-.145-1.638-1.095-2.69a.921.921 0 0 0-.68-.31h-5.45a.907.907 0 0 0-.68.31C15.142 20.362 15 22 15 22m-.308-.5h-1.384c-.17 0-.308.112-.308.25s.138.25.308.25h1.384c.17 0 .308-.112.308-.25s-.138-.25-.308-.25Zm11 0h-1.384c-.17 0-.308.112-.308.25s.138.25.308.25h1.384c.17 0 .308-.112.308-.25s-.138-.25-.308-.25ZM19 4h2.164c.241 0 .48.041.703.121.223.08.426.198.596.346.17.147.306.323.398.516.092.193.14.4.139.61V15M9 22H7.69c-.448 0-.878-.172-1.195-.477A1.599 1.599 0 0 1 6 20.372V5.628c0-.431.178-.846.495-1.151A1.724 1.724 0 0 1 7.691 4H9m8.911-2H11.09A1.08 1.08 0 0 0 10 3.071V4.93A1.08 1.08 0 0 0 11.089 6h6.822A1.08 1.08 0 0 0 19 4.929V3.07A1.08 1.08 0 0 0 17.911 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10h-7m5 4h-5m-1.8-4H10m.2 4H10",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTailoredFinanceOptions32;